import { FullWidthSpace, } from "melco-ui";
import { useMemo } from "react";
import { ControlcenterMelcoModelsHoop, DisplayFieldErrors, } from "melco-shared-logic";
import { HoopPlatformList } from "../HoopPlatformList";
import { usePlatformSelection } from "../../../hooks/hoops/usePlatformSelection";
import { useGetPlatform } from "../../../hooks/hoops/useGetPlatforms";
import { useGetSupplierProductsBySupplierType } from "../../../hooks/supplierproducts/useGetSupplierProductsBySupplierType";
import { MACHINES } from "../../../helper/suppliers";
import { HoopMachinesList } from "../HoopMachinesList";

export type HoopMachinesTabProps = {
    hoop: ControlcenterMelcoModelsHoop;
}

export const HoopMachinesTab: React.FC<HoopMachinesTabProps> = ({ hoop }) => {

    //const [{ value: hoopMachines }] = useField<any[]>("machine_list");

    const { platforms } = usePlatformSelection();
    //const { removeByPlatformIds } = useAddRemoveMachines();

    const { data: platformData } = useGetPlatform();
    const { data: machineData } = useGetSupplierProductsBySupplierType(MACHINES);

    const selectedPlatformIds = useMemo(() => platforms.map((p) => p.id), [platforms]);

    return <>
        <div>
            <DisplayFieldErrors name="machine_list" />
            <FullWidthSpace direction="vertical" size="small">
                <HoopPlatformList hoop={hoop} platformData={platformData} allMachinesData={machineData} />
                {selectedPlatformIds.length > 0 && (
                    <HoopMachinesList
                        allMachines={machineData}
                        selectedPlatformIds={selectedPlatformIds}
                    />
                )}
            </FullWidthSpace>
        </div>

    </>
}